module.exports = __webpack_public_path__ + "static/media/back_end_discord.ee9dd1bf.png";